import axios from "axios";
import config from "../config";

export const getProfile = async () => {
    const {data:{results}} = await axios(`${config.apiUrl}/api/profile`, {withCredentials: true});
    return results;
};